import { Route, Routes } from 'react-router-dom';

import { useUser } from '~/modules/auth/hooks/useUser';
import { useBrand } from '~/modules/branding';
import { ErrorContent } from '~/modules/errors/components/ErrorContent';
import { FEATURE_FLAGS } from '~/modules/experiments/features';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';

import { TabsPagesLayout } from '../../components';
import { CreateLabelPage } from './pages/CreateLabelPage';
import { DetailLabelPage } from './pages/DetailLabelPage';
import { EditLabelPage } from './pages/EditLabelPage';
import { ListLabelPage } from './pages/ListLabelPage';

export function LabelRouter() {
  const brand = useBrand();
  const { hasPermission } = useUser();

  const [manageLabelEnabled] = useFeatureFlags([
    FEATURE_FLAGS.ContainerSettingsManageLabel,
  ]);

  const canEditLabel = hasPermission('LABEL.EDIT', {
    id: brand.name,
    type: 'APPLICATION',
  });
  const canCreateLabel = hasPermission('LABEL.CREATE', {
    id: brand.name,
    type: 'APPLICATION',
  });

  return (
    <Routes>
      {manageLabelEnabled ? (
        <>
          <Route
            path="create"
            element={
              canCreateLabel ? (
                <CreateLabelPage />
              ) : (
                <ErrorContent type="noAccess" />
              )
            }
          />
          <Route
            path=":labelId/edit"
            element={
              canEditLabel ? (
                <EditLabelPage />
              ) : (
                <ErrorContent type="noAccess" />
              )
            }
          />
        </>
      ) : null}

      <Route path=":labelId" element={<DetailLabelPage />} />
      <Route element={<TabsPagesLayout />}>
        <Route path="*" element={<ListLabelPage />} />
      </Route>
    </Routes>
  );
}
LabelRouter.displayName = 'LabelRouter';
